import React from 'react';
import { Colors } from '@/common/colors/colors';
import { MetaGrid, MetaItem, ScoreBadge } from '../../callAnalysis.styles';
import {
	formatAnalyzedAt,
	formatScore,
	getAnalysisPathLabel,
	getEvaluationStatusLabel,
	scoreColor,
} from '../../helpers/labels';

const AnalysisMeta = ({ analysis }) => (
	<MetaGrid>
		<MetaItem>
			<strong>Score:</strong>{' '}
			<ScoreBadge $bg={scoreColor(analysis.overall_score)}>
				{formatScore(analysis.overall_score)}
			</ScoreBadge>
			{analysis.original_ai_score !== undefined &&
				analysis.original_ai_score !== analysis.overall_score && (
					<span style={{ marginLeft: 8, fontSize: 13 }}>
						(AI: {formatScore(analysis.original_ai_score)})
					</span>
				)}
		</MetaItem>
		<MetaItem>
			<strong>Evaluation status:</strong>{' '}
			{getEvaluationStatusLabel(analysis.evaluation_status)}
		</MetaItem>
		<MetaItem>
			<strong>Path:</strong> {getAnalysisPathLabel(analysis.analysis_path)}
		</MetaItem>
		<MetaItem>
			<strong>AI confidence:</strong> {analysis.confidence_level ?? 0}%
		</MetaItem>
		<MetaItem>
			<strong>Analyzed at:</strong> {formatAnalyzedAt(analysis.analyzed_at)}
		</MetaItem>
		<MetaItem>
			<strong>Reliable:</strong> {analysis.is_reliable ? 'Yes' : 'No'}
		</MetaItem>
		{analysis.inbound_reason && (
			<MetaItem>
				<strong>Inbound reason:</strong> {analysis.inbound_reason}
			</MetaItem>
		)}
		{analysis.has_critical_error && (
			<MetaItem>
				<strong style={{ color: Colors.red }}>Critical error:</strong> Yes
			</MetaItem>
		)}
	</MetaGrid>
);

export default AnalysisMeta;
